export default {
  SET_REGION: (state, region) => {
    state.bucketParameter.region = region
  },
  SET_ACCESSKEYID: (state, accessKey) => {
    state.bucketParameter.accessKeyId = accessKey
  },
  SET_ACCESSKEYSECRET: (state, secret) => {
    state.bucketParameter.accessKeySecret = secret
  },
  SET_BUCKET: (state, bucket) => {
    state.bucketParameter.bucket = bucket
  },
  SET_SECURE: (state, secure) => {
    state.bucketParameter.secure = secure
  },
  SET_REFRESH: (state, secure) => {
    state.refresh = secure
  },
}



// WEBPACK FOOTER //
// ./src/store/common/mutations.js